import React from "react";

export default function LoadingSpinner() {
  return (
    <div className="spinner-container">
      <div className="loading-spinner"></div>
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/components/bewise/exclusiveparnter/LoadingSpinner.jsx